<template>
<div class="flex -mx-4 flex-col">
    <div @click="updateAlbum" class="text-grey-darker text-2xl mb-6">
        Album: {{this.title}}    
    </div>

    <div class="flex flex-row flex-grow h-full" :class="{'opacity-25' : isLoading}">
      <!-- Data -->
      <form class="w-full max-w-md border-r border-grey-lighter pr-4">
        <!-- Top part -->
        <div class="mb-2 text-grey text-bold text-sm mb-4">
          {{this.labelDetailsOptions}}
        </div>

        <div class="flex flex-wrap -mx-3">
          <div class="w-full md:w-2/3 px-3 mb-6 md:mb-0">
            <!-- Title -->
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-title">
              <span>{{this.labelTitle}}</span>
              <span class="text-red">*</span>
            </label>

            <input v-model="title" class="appearance-none block w-full bg-grey-lightest text-grey-darker rounded py-3 px-3 mb-3 leading-tight border border-grey-lighter focus:outline-none focus:bg-white focus:border-grey" id="grid-title" type="text" :placeholder="this.placeholderTitle">
          </div>

          <!-- Event Date -->
          <div class="w-full md:w-1/3 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-date">
              {{this.labelEventDate}}
            </label>

            <input v-model="eventDate" 
            class="appearance-none block w-full bg-grey-lightest text-grey-darker border border-grey-lighter rounded py-3 px-3 leading-tight focus:outline-none focus:bg-white focus:border-grey" id="grid-eventDate" type="text" 
            :placeholder="this.placeholderEventDate">
          </div>
        </div>

        <div class="flex flex-wrap -mx-3 mt-4">
          <div class="w-full md:w-2/3 px-3 mb-6 md:mb-0">
            <!-- Password -->
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-password">
              <span>{{this.labelPassword}}</span>
              <span class="text-red">*</span>
            </label>

            <input v-model="password" class="appearance-none block w-full bg-grey-lightest text-grey-darker rounded py-3 px-3 mb-3 leading-tight border border-grey-lighter focus:outline-none focus:bg-white focus:border-grey" 
            id="grid-password" type="text">
          </div>

          <!-- Exp. Date -->
          <div class="w-full md:w-1/3 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-date">
              {{this.labelCloseDate}}
            </label>

            <input v-model="closeDate" 
            class="appearance-none block w-full bg-grey-lightest text-grey-darker border border-grey-lighter rounded py-3 px-3 leading-tight focus:outline-none focus:bg-white focus:border-grey" id="grid-closeDate" type="text" 
            :placeholder="this.placeholderCloseDate">
          </div>
        </div>

        <!-- Bottom part -->
        <div class="mt-4 mb-2 text-grey text-bold text-sm mb-4">
          {{this.labelPrivacyOptions}}
        </div>

        <div class="flex flex-wrap -mx-3">
          <!-- Status -->
          <div class="w-full md:w-1/3 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold" for="grid-status">
              {{this.labelArchive}}
            </label>

            <TailwindSwitch id="grid-status" class="flex block items-center py-3" 
            idName="status"
            :value="this.isAlbumActive"
            :onText="checkboxStatusOn"
            :offText="checkboxStatusOff" />
          </div>

          <!-- Email required -->
          <div class="w-full md:w-1/3 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold" for="grid-requires-email">
              {{this.labelRequiresEmail}}
            </label>

            <TailwindSwitch id="grid-requires-email" class="flex block w-full items-center py-3" 
            idName="emailRequired"
            :value="this.isEmailRequired"
            :onText="checkboxEmailRequiredOn"
            :offText="checkboxEmailRequiredOff" />
          </div>

          <!-- Email required -->
          <div class="w-full md:w-1/3 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold" for="grid-allows-comments">
              {{this.labelAllowComments}}
            </label>

            <TailwindSwitch id="grid-allows-comments" class="flex block w-full items-center py-3" 
            idName="allowsComments"
            :value="this.isCommentsAllowed"
            :onText="checkboxAllowsCommentsOn"
            :offText="checkboxAllowsCommentsOff" />
          </div>
        </div>

        <!-- Upload photos -->
        <div class="mt-4 mb-4 text-grey text-bold text-sm">
          {{this.labelUploadPhotos}}
        </div>

        <div class="flex">
          <photo-file-upload  class="w-full mb-6 md:mb-0" :albumId="this.albumId" />
        </div>
      </form>


      <!-- Right side -->
      <div class="w-full pl-4">
        
        <!-- Cover -->
        <div class="text-grey text-bold text-sm mb-2">
          {{this.labelCover}}
        </div>

        <img class="w-full rounded mb-2" style="object-fit: center-crop" :src="this.cover ? (this.cover + '&w=400&h=150'): 'http://kemri-wellcome.org/wp-content/themes/kemri/img/img_placeholder.png'" alt="Album cover">
        
        <!-- Gallery -->
        <div class="flex flex-row w-full flex-wrap -ml-1">
          <div class="flex" v-for="photo in this.albumPhotos" :key="photo.id">
            <img @click="setCover(photo)" 
            :class="{'border-grey-lighter': photo !== cover,
                    'border-pink shadow': photo === cover}"
            class="w-24 h-24 border m-1 rounded hover:shadow" 
            style="object-fit: cover" 
            :src="photo ? (photo + '&w=200&h=100') : 'http://kemri-wellcome.org/wp-content/themes/kemri/img/img_placeholder.png'" 
            alt="Album photo">
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import TailwindSwitch from "./TailwindSwitch";
import PhotoFileUpload from "./PhotoFileUpload";
import AlbumsRepository from "../repositories/AlbumsRepository";

export default {
  name: "AlbumDetails",
  components: {
    Spinner,
    PhotoFileUpload,
    TailwindSwitch
  },
  props: {},

  data() {
    return {
      // Screen
      screenTitleText: "Update Details",
      isLoading: true,
      // Data
      albumId: this.$route.params.id,
      title: "",
      eventDate: "",
      closeDate: "",
      password: "",
      cover: "",
      isAlbumActive: false,
      isEmailRequired: false,
      isCommentsAllowed: false,
      albumPhotos: [],

      // Form
      labelTitle: "Title",
      placeholderTitle: "Jessy and James Wedding",
      labelDetailsOptions: "Details",

      labelEventDate: "Event Date",
      placeholderEventDate: "12/04/2019",

      labelPassword: "Password",

      labelCloseDate: "Close Date",
      placeholderCloseDate: "12/04/2019",

      labelArchive: "Status",
      checkboxStatusOn: "Active",
      checkboxStatusOff: "Inactive",

      labelPrivacyOptions: "Options",

      labelRequiresEmail: "Email required",
      checkboxEmailRequiredOn: "Required",
      checkboxEmailRequiredOff: "No",

      labelAllowComments: "Allow comments",
      checkboxAllowsCommentsOn: "Yes",
      checkboxAllowsCommentsOff: "No",

      labelUploadPhotos: "Upload Photos",

      labelCover: "Cover",

      doneButtonText: "Done",
      createButtonText: "Create",
      cancelButtonText: "Cancel",

      isCreateAlbumLoading: false
    };
  },

  created() {
    AlbumsRepository.get(this.albumId, album => {
      this.isLoading = false

      this.title = album.title;
      this.password = album.password;
      this.isAlbumActive = album.is_active;
      this.isEmailRequired = album.is_email_required;
      this.isCommentsAllowed = album.is_comments_allowed;
      this.cover = album.cover;
      this.albumPhotos = album.photos;

      console.log("Album title " + album.title);
      console.log("Album date " + album.event_date);
      console.log("Album active " + album.is_active);
      console.log("Album cover " + album.cover);
      console.log("Album photos " + album.photos);
      console.log("Album ownerId " + album.owner_id);
      console.log("Album ownerName " + album.owner_name);
      console.log("Album ownerPhotoUrl " + album.owner_photo_url);
    });

    // .catch(error => {
    //   console.log("Album Failed " + error);
    // });
  },

  computed: {
    isCreateEnabled() {
      return this.title.length > 0;
    },

    isAlbumCreated() {
      return this.albumId.length > 0;
    },

    createdAlbumId() {
      return this.albumId;
    }
  },

  mounted() {},

  methods: {
    updateAlbum() {
      console.log("updateAlbum");
      AlbumsRepository.get(this.albumId)
        .then(album => {
          console.log("album is: " + album.data);
        })
        .catch(error => {
          console.log("Album Failed " + error);
        });
    },

    setCover(photo) {
      this.cover = photo
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AlbumDetails.vue